export const EXHIBITION_ID = {
  EDUCATION: 14,
  TRADE: 15
}
export const EXHIBITION_NAME = {
  EDUCATION: 'EDUCATION',
  TRADE: 'TRADE'
}
// 首页进入大厅转场视频地址
export const INDEX_TRANS_VIDEO_URL =  {
  // 教育馆
  EDUCATION: 'https://pub-vhall.oss-cn-hangzhou.aliyuncs.com/IDEE/%E5%A4%A7%E5%8E%85-9M.mp4',
  // 贸易馆
  TRADE: 'https://static.cloudvhall.com/DTSW/%E4%BC%9A%E8%AE%AEDT.mp4'
}
// // 首页进入大厅转场定帧图片地址
export const INDEX_TRANS_IMAGE_URL =  {
  // 教育馆
  EDUCATION: '',
  // 贸易馆
  TRADE: ''
}
// 咨询台过场动画
export const CONSULTANT_VIDEO_URL = {
  EDUCATION: 'https://pub-vhall.oss-cn-hangzhou.aliyuncs.com/IDEE/%E4%BC%9A%E8%AE%AE%E5%A4%A7%E5%8E%85.mp4',
  TRADE: 'https://static.cloudvhall.com/DTSW/%E4%BC%9A%E8%AE%AEDT2.mp4'
}
// 咨询台过场定帧图片
export const CONSULTANT_IMAGE_URL = {
  EDUCATION: '',
  TRADE: ''
}
// 会议区过场定帧图片
export const MEETING_IMAGE_URL = {
  EDUCATION: '',
  TRADE: ''
}
// 论坛区过场动画
export const FORUM_VIDEO_URL = {
  EDUCATION: 'https://pub-vhall.oss-cn-hangzhou.aliyuncs.com/IDEE/%E8%AE%BA%E5%9D%9B%E5%8C%BA.mp4',
  TRADE: 'https://static.cloudvhall.com/DTSW/%E7%82%B9%E5%87%BB%E4%BC%9A%E8%AE%AE%E5%8E%85.mp4'
}
// 路演区过场动画
export const ROAD_VIDEO_URL = {
  EDUCATION: 'https://pub-vhall.oss-cn-hangzhou.aliyuncs.com/IDEE/%E8%B7%AF%E6%BC%94%E5%8C%BA.mp4',
  TRADE: 'https://static.cloudvhall.com/DTSW/%E7%82%B9%E5%87%BB%E8%B7%AF%E6%BC%94%E5%8E%85.mp4'
}
// 展位页侧边按钮列表
export const DETAIL_PAGE_BUTTON = {
  INTRO: 1,
  VIDEO: 2,
  PRODUCT: 3,
  CONTACT: 4,
  CARD: 5,
  CHAT: 6,
  PRODUCT_DETAIL: 7,
  POSTER: 8
}



// WEBPACK FOOTER //
// ./src/assets/common/data.js